import React from "react";
// import { Spinner } from "react-bootstrap";
import { Button, Form, Modal, Spinner } from "react-bootstrap";

import investorApp from "../Shared/Controller/investorApp";
import Axios from 'axios'
import * as Constants from "../partials/CommonConstant";
import "react-data-table-component-extensions/dist/index.css";
import { error } from "jquery";
import { ShowToast } from "../common/CommonController";

class Translate extends investorApp {
    constructor(props) {
        super(props);
        this.handleValidationFile = this.handleValidationFile.bind(this);
        this.state = {
            sourceLanguage: '',
            targetLanguage: '',
            loading: false,
            selectedFile: null,
            successMessage: "",
            downloadUrl: "",
            dragOver: false,
            errors: false,
        };
        this.fileInputRef = React.createRef();
    }

    handleFileChange = (e) => {
        const file = e.target.files[0];
        this.handleValidationFile = (file)
        if (file) {
            this.setState({ selectedFile: file });
        }
    };

    handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const file = e.dataTransfer.files[0];
        this.handleValidationFile(file)
        if (file) {
            this.setState({ selectedFile: file, dragOver: false });
        }

    };

    handleValidationFile = (file) => {
        const validExtensions = [".xlsx", ".docx", ".pdf"];
        const fileName = file.name.toLowerCase();
        const isValid = validExtensions.some(ext => fileName.endsWith(ext));
        if (!isValid) {
            this.setState({
                errors: true,
            });
            this.setState({ selectedFile: '' });
            return;
        }
        else {
            this.setState({
                errors: false,
            });
        }
    }

    handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.setState({ dragOver: true });
    };

    handleDragLeave = () => {
        this.setState({ dragOver: false });
    };

    triggerFileDialog = () => {
        this.fileInputRef.current.click();
    };

    handleUpload = async () => {
        const { selectedFile, sourceLanguage, targetLanguage } = this.state;
        const validExtensions = [".xlsx", ".docx", ".pdf"];
        const fileName = selectedFile?.name?.toLowerCase();
        const isValid = validExtensions?.some(ext => fileName?.endsWith(ext));
        const errors = {};
        if (!sourceLanguage) errors.sourceLanguage = 'Source language is required';
        if (!targetLanguage) errors.targetLanguage = 'Target language is required';
        if (sourceLanguage && targetLanguage && sourceLanguage === targetLanguage) {
            errors.targetLanguage = 'Source and target languages must be different';
        }

        if (!selectedFile) errors.selectedFile = 'File is required';

        if (Object.keys(errors).length > 0) {
            this.setState({ errors });
            return;
        }

        if (!isValid) {
            this.setState({
                errors: true,
                selectedFile: ''
            });
            return;
        }

        this.setState({ loading: true, errors: {} });

        const formData = new FormData();
        formData.append("doc_file", selectedFile);
        formData.append("source_lang", sourceLanguage);
        formData.append("target_lang", targetLanguage);

        try {
            this.setState({
                errors: false,
            });
            Axios.post(Constants.TranslateSheet, formData).then(response => {
                if (response.status == 200) {
                    ShowToast("message", "success", response?.data?.data?.message)

                    this.setState({
                        successMessage: response?.data?.data?.message,
                        downloadUrl: response?.data?.data?.download_url,
                        loading: false,
                    });
                    const downloadUrl = response?.data?.data?.download_url.replace(/\\\//g, '/').replace(/\\\\/g, '\\');
                    this.triggerDownload(downloadUrl);
                }
                else {
                    ShowToast("message", "error", response?.data?.data?.message)
                    this.setState({ loading: false });
                }
            })
                .catch(error => {
                    this.setState(error.response ? error.response.data.errors : []);
                })
        } catch (err) {
            this.setState({ loading: false });
        }
    };

    triggerDownload = (url) => {
        const a = document.createElement("a");
        a.href = url;
        a.download = "";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        this.setState({ selectedFile: '' });
        this.setState({ sourceLanguage: '' })
        this.setState({ targetLanguage: '' })
    };


    render() {
        const { loading, successMessage, selectedFile, dragOver, errors } = this.state;
        const translationSourceLanguages = [
            { code: 'AR', label: 'Arabic' },
            { code: 'BG', label: 'Bulgarian' },
            { code: 'CS', label: 'Czech' },
            { code: 'DA', label: 'Danish' },
            { code: 'DE', label: 'German' },
            { code: 'EL', label: 'Greek' },
            { code: 'EN', label: 'English' },
            { code: 'EN-GB', label: 'English (British)' },
            { code: 'EN-US', label: 'English (American)' },
            { code: 'ES', label: 'Spanish' },
            { code: 'ET', label: 'Estonian' },
            { code: 'FI', label: 'Finnish' },
            { code: 'FR', label: 'French' },
            { code: 'HE', label: 'Hebrew' },
            { code: 'HU', label: 'Hungarian' },
            { code: 'ID', label: 'Indonesian' },
            { code: 'IT', label: 'Italian' },
            { code: 'JA', label: 'Japanese' },
            { code: 'KO', label: 'Korean' },
            { code: 'LT', label: 'Lithuanian' },
            { code: 'LV', label: 'Latvian' },
            { code: 'NB', label: 'Norwegian Bokmål' },
            { code: 'NL', label: 'Dutch' },
            { code: 'PL', label: 'Polish' },
            { code: 'PT', label: 'Portuguese' },
            { code: 'PT-BR', label: 'Portuguese (Brazilian)' },
            { code: 'PT-PT', label: 'Portuguese' },
            { code: 'RO', label: 'Romanian' },
            { code: 'RU', label: 'Russian' },
            { code: 'SK', label: 'Slovak' },
            { code: 'SL', label: 'Slovenian' },
            { code: 'SV', label: 'Swedish' },
            { code: 'TR', label: 'Turkish' },
            { code: 'UK', label: 'Ukrainian' },
            { code: 'VI', label: 'Vietnamese' },
            { code: 'ZH', label: 'Chinese' },
            { code: 'ZH-HANS', label: 'Chinese' },
            { code: 'ZH-HANT', label: 'Chinese' },
        ];
        const translationTargetLanguages = [
            { code: 'AR', label: 'Arabic' },
            { code: 'BG', label: 'Bulgarian' },
            { code: 'CS', label: 'Czech' },
            { code: 'DA', label: 'Danish' },
            { code: 'DE', label: 'German' },
            { code: 'EL', label: 'Greek' },
            { code: 'EN', label: 'English' },
            { code: 'EN-GB', label: 'English' },
            { code: 'EN-US', label: 'English' },
            { code: 'ES', label: 'Spanish' },
            { code: 'ET', label: 'Estonian' },
            { code: 'FI', label: 'Finnish' },
            { code: 'FR', label: 'French' },
            { code: 'HE', label: 'Hebrew (Pro v2 API, next-gen models only)' },
            { code: 'HU', label: 'Hungarian' },
            { code: 'ID', label: 'Indonesian' },
            { code: 'IT', label: 'Italian' },
            { code: 'JA', label: 'Japanese' },
            { code: 'KO', label: 'Korean' },
            { code: 'LT', label: 'Lithuanian' },
            { code: 'LV', label: 'Latvian' },
            { code: 'NB', label: 'Norwegian Bokmål' },
            { code: 'NL', label: 'Dutch' },
            { code: 'PL', label: 'Polish' },
            { code: 'PT', label: 'Portuguese' },
            { code: 'PT-BR', label: 'Portuguese' },
            { code: 'PT-PT', label: 'Portuguese' },
            { code: 'RO', label: 'Romanian' },
            { code: 'RU', label: 'Russian' },
            { code: 'SK', label: 'Slovak' },
            { code: 'SL', label: 'Slovenian' },
            { code: 'SV', label: 'Swedish' },
            { code: 'TR', label: 'Turkish' },
            { code: 'UK', label: 'Ukrainian' },
            { code: 'VI', label: 'Vietnamese' },
            { code: 'ZH', label: 'Chinese' },
            { code: 'ZH-HANS', label: 'Chinese' },
            { code: 'ZH-HANT', label: 'Chinese' },
        ];
        return (
            <div className="dashboard-card-wrapper">
                <div className="card-main p-4">
                    <div className="row">
                        {/* Source Language Dropdown */}
                        <div className="col-md-6 mt-3">
                            <Form.Group controlId="sourceLanguage" className="mb-3">
                                <Form.Label>Source Language</Form.Label>
                                <Form.Control
                                    as="select"
                                    className="form-select"
                                    value={this.state.sourceLanguage}
                                    onChange={(e) => this.setState({ sourceLanguage: e.target.value })}
                                    isInvalid={!!this.state.errors?.sourceLanguage}
                                >
                                    <option value="">Select Source Language</option>
                                    {translationSourceLanguages.map((lang) => (
                                        <option key={lang.code} value={lang.code}>
                                            {lang.code} - {lang.label}
                                        </option>
                                    ))}
                                </Form.Control>
                                <Form.Control.Feedback type="invalid">
                                    {this.state.errors?.sourceLanguage}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </div>

                        {/* Target Language Dropdown */}
                        <div className="col-md-6 mt-3">
                            <Form.Group controlId="targetLanguage" className="mb-3">
                                <Form.Label>Target Language</Form.Label>
                                <Form.Control
                                    as="select"
                                    className="form-select"
                                    value={this.state.targetLanguage}
                                    onChange={(e) => this.setState({ targetLanguage: e.target.value })}
                                    isInvalid={!!this.state.errors?.targetLanguage}
                                >
                                    <option value="">Select Target Language</option>
                                    {translationTargetLanguages.map((lang) => (
                                        <option key={lang.code} value={lang.code}>
                                            {lang.code} - {lang.label}
                                        </option>
                                    ))}
                                </Form.Control>
                                <Form.Control.Feedback type="invalid">
                                    {this.state.errors?.targetLanguage}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </div>
                    </div>

                    {/* File Upload Section */}
                    <div className="mt-4">
                        <Form.Label>Upload Document for Translation</Form.Label>

                        <div
                            onClick={this.triggerFileDialog}
                            onDrop={this.handleDrop}
                            onDragOver={this.handleDragOver}
                            onDragLeave={this.handleDragLeave}
                            className={`border border-dashed p-5 text-center rounded ${this.state.dragOver ? "bg-light border-primary" : "bg-white"}`}
                            style={{
                                border: this.state.errors ? "1px solid red" : "1px solid #ccc",
                                cursor: "pointer",
                            }}
                        >
                            <p className="text-muted">
                                {this.state.selectedFile
                                    ? `Selected File: ${this.state.selectedFile.name}`
                                    : "Drag & drop your .xlsx ,.docx,.pdf file here, or click to select"}
                            </p>
                            <input
                                type="file"
                                accept=".xlsx,.docx,.pdf,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                onChange={this.handleFileChange}
                                ref={this.fileInputRef}
                                style={{ display: "none" }}
                            />
                        </div>
                        {this.state.errors && (
                            <span style={{ color: "red" }}>Please select a valid file to upload</span>
                        )}
                    </div>

                    {/* Upload Button */}
                    <div className="form-btn mt-4">
                        <button
                            className="btn btn-primary w-25"
                            onClick={this.handleUpload}
                            disabled={this.state.loading}
                        >
                            {this.state.loading ? (
                                <>
                                    <Spinner animation="border" size="sm" /> Uploading...
                                </>
                            ) : (
                                "Upload & Translate"
                            )}
                        </button>
                    </div>

                    {/* Success Message */}
                    {this.state.successMessage && (
                        <div className="alert alert-success mt-3">
                            ✅ {this.state.successMessage}
                        </div>
                    )}
                </div>
            </div>

        );
    }
}

export default Translate;
